export default (regNum?: string): string =>
  regNum ? regNum.replace(/[A-Z]{2}/, regNum.slice(0, 2) + ' ') : regNum || ''
